import React, { useEffect } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { SlClock } from "react-icons/sl";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { getNonRealDashoard } from "../../../core/data/redux/dashboard/_dashboardAction";
import ActiveBusinessHourIcon from "../../../icons/ActiveBusinessHourIcon";
import PassiveInvestmentHourIcon from "../../../icons/PassiveInvestmentHourIcon";
import TotalActivitiesIcon from "../../../icons/TotalActivitiesIcon";
import TotalHoursIcon from "../../../icons/TotalHoursIcon";
import ActivityOverviewDashboardList from "../../../core/components/common/activityOverviewDashboardList";
import { formatDateString, logHourFormatTime } from "../../../constants/date";
import { capitalizeFullName } from "../../../constants/common";

const NonRealdashboard: React.FC = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();

  const nonRealDashboardState = useSelector((state: any) => state?.dashboard);
  const dashboardData = nonRealDashboardState?.nonRealDashoard;

  useEffect(() => {
    fertchDashboardData();
  }, [dispatch]);

  const fertchDashboardData = async () => {
    await dispatch(getNonRealDashoard({}));
  };

  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">
        <div className="profileSettings non-real-dahboard-page-section">
          <div className="rounded non-real-dahboard-page">
            <div className="add-properties-heading d-flex justify-content-between align-items-center gap-3 mb-4">
              <div className="property-area">
                <h2 className="mb-0">Dashboard</h2>
              </div>
            </div>

            <div className="row g-3 mt-3 mb-3 pb-3 pt-3 dashboard-row">
              <div className="grid-container ">
                <div className="box">
                  <div className="custom-card mx-auto">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-top flex-wrap">
                        <div className="text-area text-left">
                          <h5 className="mb-0  ">Active Business Hours</h5>
                          <h3 className="mb-0 fw-bold box-active mt-2 mb-3">
                            {dashboardData?.total_active_log_hours}
                          </h3>
                        </div>
                        <div className="icon-area">
                          <ActiveBusinessHourIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="box">
                  <div className="custom-card mx-auto">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-top flex-wrap"> 
                        <div className="text-area text-left">
                          <h5 className="mb-0 ">Passive Investment Hours</h5>
                          <h3 className="mb-0 fw-bold box-hours mt-2 mb-3">
                            {dashboardData?.total_passive_log_hours}
                          </h3>
                        </div>
                        <div className="icon-area">
                          <PassiveInvestmentHourIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="box">
                  <div className="custom-card mx-auto">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-top flex-wrap">
                        <div className="text-area text-left">
                          <h5 className="mb-0  ">Total Activities</h5>
                          <h3 className="mb-0 fw-bold box-four mt-2 mb-3">
                            {dashboardData?.total_activities}
                          </h3>
                        </div>
                        <div className="icon-area">
                          <TotalActivitiesIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="box">
                  <div className="custom-card mx-auto">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-top flex-wrap">
                        <div className="text-area text-left">
                          <h5 className="mb-0  ">Total Hours</h5>
                          <h3 className="mb-0 fw-bold box-combined mt-2 mb-3">
                            {dashboardData?.total_log_hours}
                          </h3>
                        </div>
                        <div className="icon-area">
                          <TotalHoursIcon />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-3 mt-3 mb-3 ">
              <div className="col-sm-12">
                <div className="pb-3 pt-3 activity-overview row-boder-line">
                  <div className="box-text-area d-flex justify-content-between mb-3">
                    <h5>Activity Overview</h5>
                    <div className="box-text-right d-flex">
                      <ul className="status-list">
                        <li className="active">
                          Active ({dashboardData?.total_active_log_hours}h)
                        </li>
                        <span className="divider">|</span>
                        <li className="passive">
                          Passive ({dashboardData?.total_passive_log_hours}h)
                        </li>
                      </ul>
                    </div>
                  </div>

                  {dashboardData?.recent_activites?.length > 0 ? (
                    <div className="grid-container mt-0">
                      <ActivityOverviewDashboardList
                        data={dashboardData?.recent_activites}
                      />
                    </div>
                  ) : (
                    <div className="text-center">
                      <p className="m-4">No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row g-3 mt-3 mb-3">
              <div className="col-sm-12">
                <div className="pb-3 pt-3  row-boder-line">
                  <div className="box-text-area recentr-time-entries d-flex align-items-center gap-2  mb-3">
                    <SlClock />
                    <h5 className="mb-0"> Recent Time Entries</h5>
                  </div>

                  {dashboardData?.recent_log_hours?.length > 0 ? (
                    <div className="grid-container recent-time-section mt-0">
                      <div className="grid">
                        {dashboardData?.recent_log_hours?.length > 0 &&
                          dashboardData?.recent_log_hours?.map(
                            (entry: any, index: number) => (
                              <div className="card bg-blue mb-2">
                                <div className="card-content">
                                  <div className="title-row">
                                    <div className="title-inner">
                                      <div className="dot-area">
                                        <div className="dot"></div>
                                        <div className="title">
                                          {entry?.type?.name}
                                        </div>
                                        <div className="title-time">
                                          <div
                                            className={
                                              entry?.participation_level.toLowerCase() ==
                                              "active"
                                                ? "status2"
                                                : "status"
                                            }
                                          >
                                            {capitalizeFullName(
                                              entry?.participation_level
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="subtitle text-left">
                                        {entry?.task_description}
                                      </div>
                                      <div className="date">
                                        {formatDateString(entry?.date)}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                
                                <div className="duration">
                                  {logHourFormatTime({
                                    hours: entry?.hours,
                                    minutes: entry?.minutes,
                                  })}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center">
                      <p className="m-4">No data available</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NonRealdashboard;
